const AUTH_TOKEN_KEY = "esumei.auth.idToken";
const REFRESH_TOKEN_KEY = "esumei.auth.refreshToken";
const PREVIEW_SUBJECT_KEY = "esumei.preview.subject";
const ORGANIZATION_ID_KEY = "esumei.organization.id";

function safeGet(key: string): string {
  try {
    return window.localStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

function safeSet(key: string, value: string): void {
  try {
    if (value === "") {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function readAuthToken(): string {
  return safeGet(AUTH_TOKEN_KEY);
}

export function writeAuthToken(token: string): void {
  safeSet(AUTH_TOKEN_KEY, token);
}

export function readRefreshToken(): string {
  return safeGet(REFRESH_TOKEN_KEY);
}

export function writeRefreshToken(token: string): void {
  safeSet(REFRESH_TOKEN_KEY, token);
}

export function clearAuthTokens(): void {
  writeAuthToken("");
  writeRefreshToken("");
}

export function readPreviewSubject(): string {
  return safeGet(PREVIEW_SUBJECT_KEY);
}

export function writePreviewSubject(subject: string): void {
  safeSet(PREVIEW_SUBJECT_KEY, subject);
}

export function readOrganizationId(): string {
  return safeGet(ORGANIZATION_ID_KEY);
}

export function writeOrganizationId(organizationId: string): void {
  safeSet(ORGANIZATION_ID_KEY, organizationId);
}
